import React from 'react'
import {withRouter} from 'react-router-dom'
import MenuCategoryListView from './MenuCategoryListView'
import openPhotoSwipe from './openPhotoSwipeGallery'
import {Consumer} from './ShopDataContainer'
import AutoMenuNavigator from './AutoMenuNavigator'
import PromoAccessForm from './PromoAccessForm'
import AutoMenuHeader from './AutoMenuHeader'



class AutoMenu extends React.PureComponent {
  constructor() {
    super();
    let records = []

    this.state = { menu: records, info: {}, galleryIsOpen: false, searchQuery: '', compactMode: false, highlightedCategoryId: null, copiedCategoryId: null };
    this.openPhotoSwipeGallery = this.openPhotoSwipeGallery.bind(this)
    this.onAddCurrentSlideToCart = this.onAddCurrentSlideToCart.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.toggleCompactMode = this.toggleCompactMode.bind(this)
    this.copyCategoryLink = this.copyCategoryLink.bind(this)
    this.handleHashNavigation = this.handleHashNavigation.bind(this)
    this.clearCopyState = this.clearCopyState.bind(this)

    this.focusRef = React.createRef()
  }

  componentDidMount () {


    let productIdToFocus = null
    try {
      productIdToFocus = window['product-id-to-focus']
      // console.log(productIdToFocus)
    } catch(e) {}

    if (!productIdToFocus && this.props.shouldFocus) {
      try {
        console.log('focusing to menu')
        this.focusRef.current.focus()
      } catch(e) {
      }
    }

    if (productIdToFocus && this.props.shouldFocus) {
      console.log('🐞 focusing: ' + productIdToFocus)
      try { window['product-id-to-focus'] = null } catch(e) {}
      try {

        const productEle = document.querySelector(`#p_${productIdToFocus}`)
        productEle.setAttribute('tabindex', '-1')
        productEle.focus()
        productEle.scrollIntoView()
      } catch(e) {
        console.log(e)
      }
    }

    // If URL has a category hash, scroll to it after render
    this.handleHashNavigation();
    window.addEventListener('hashchange', this.handleHashNavigation);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashNavigation);
    this.clearCopyState();
  }

  handleSearch(query) {
    // Auto-enable compact mode when searching
    this.setState({ 
      searchQuery: query,
      compactMode: query ? true : this.state.compactMode 
    })
  }

  toggleCompactMode() {
    this.setState(prev => ({ compactMode: !prev.compactMode }))
  }

  onAddCurrentSlideToCart() {
    // console.log('clicked')
    if (!this.gallery) { return }
    let product = this.gallery.currItem && this.gallery.currItem.product
    // let cartItemId = global.__addToCart(product)
    this.gallery.close()
    this.props.history.push(`/products/${product.id}`)

  }
  openPhotoSwipeGallery(productId, event) {
    let allProducts = []
    this.props.menu.subMenus.forEach(({products}) => allProducts = [...allProducts, ...products])
    let gallery = openPhotoSwipe(productId, allProducts)
    this.gallery = gallery
    this.setState({ galleryIsOpen: true })
    gallery.listen('close', () => {
      this.setState({ galleryIsOpen: false })
      this.gallery = null
    })

  }

  copyCategoryLink(categoryId) {
    const hash = `#menu-category-${categoryId}`
    const url = `${window.location.origin}${window.location.pathname}${hash}`
    this.clearCopyState()
    const markCopied = () => {
      this.setState({ copiedCategoryId: categoryId })
      this._copyTimer = setTimeout(() => this.clearCopyState(), 1600)
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(markCopied).catch(() => {
        try {
          const input = document.createElement('input')
          input.value = url
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
          markCopied()
        } catch(e) {
          console.log('Copy failed', e)
        }
      })
    } else {
      try {
        const input = document.createElement('input')
        input.value = url
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        markCopied()
      } catch(e) {
        console.log('Copy failed', e)
      }
    }
  }

  handleHashNavigation() {
    const hash = window.location.hash || ''
    if (hash && hash.indexOf('#menu-category-') === 0) {
      const catId = hash.replace('#menu-category-', '')
      this.setState({ highlightedCategoryId: catId })
      // center scroll the heading
      const target = document.querySelector(hash)
      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'center' })
      }
    }
  }

  clearCopyState() {
    if (this._copyTimer) {
      clearTimeout(this._copyTimer)
      this._copyTimer = null
    }
    if (this.state.copiedCategoryId) {
      this.setState({ copiedCategoryId: null })
    }
  }

  render() {
    console.log('rendering long ass menu')

    let {menu, settings, hideNav, noPhoto, altStyleA, noOrder, locations, restId, darkMode} = this.props
    console.log('automenu props:', {darkMode, altStyleA})
    settings = settings || {}

    console.log('locations', locations, 'restId', restId)

    if (!menu || !menu.subMenus) {
      console.log('no menu')
      return null}

    const {name, address} = {}

    let subMenus = menu.subMenus
    // filter based on ids
    if (this.props.categorysToShow) {
      subMenus = subMenus.filter(({id}) => {
        return (this.props.categorysToShow.indexOf(id) > -1)
      })
    }
    // filter based on name
    if (this.props.legacy__namesToShow) {
      subMenus = subMenus.filter(({name}) => {
        return (this.props.legacy__namesToShow.indexOf(name) > -1)
      })
    }

    if (this.props.tagsToShow) {
      subMenus = subMenus.filter(({tag}) => {
        if (!tag) { return false}
        let hasTag = false
        this.props.tagsToShow.forEach((tagToShow) => {
          hasTag = tag.indexOf(tagToShow) !== -1
          if (hasTag) { return false }
        })
        return hasTag
      })
    }

    if (this.props.subMenuFilter) {
      subMenus = subMenus.filter(this.props.subMenuFilter)
    }
    if (this.props.subMenuDisableFilter) {
      subMenus = subMenus.map(this.props.subMenuDisableFilter)
    }

    if (this.props.shopId) {
      subMenus = subMenus.filter(({shopId}) => {
        return this.props.shopId === shopId
      })
    }
    // console.log('noPhoto', noPhoto)
    
    if (this.props.location.state && this.props.location.state.startAtTop) {
      window.scrollTo(0,0)
    }

    // Filter products based on search query
    const { searchQuery, compactMode, highlightedCategoryId, copiedCategoryId } = this.state
    let filteredSubMenus = subMenus
    let totalSearchResults = 0
    if (searchQuery) {
      const query = searchQuery.toLowerCase()
      filteredSubMenus = subMenus.map(subMenu => ({
        ...subMenu,
        products: subMenu.products.filter(product => {
          const productName = (product.name?.en || '').toLowerCase()
          const productDesc = (product.description?.en || '').toLowerCase()
          return productName.includes(query) || productDesc.includes(query)
        })
      })).filter(subMenu => subMenu.products.length > 0)

      totalSearchResults = filteredSubMenus.reduce((acc, subMenu) => acc + subMenu.products.length, 0)
    }

    // Determine if we should show compact mode (auto when searching, or manual toggle)
    const isCompact = compactMode || !!searchQuery
    const searchActive = !!searchQuery


    return (<div className="menu-story" role="main">

      <header
        style={{
          opacity: 0,
          height: 0
        }}

        >

        <h1
          tabIndex={-1}
          ref={this.focusRef}
          >Ordering Menu</h1>
      </header>

      <div className="nav-and-menu-wrapper">
        
        <AutoMenuHeader
          locations={locations}
          restId={restId}
          darkMode={darkMode}
        />
        
        <div className="menu-content-area">
          {!hideNav && <AutoMenuNavigator
            darkMode={darkMode}
            subMenus={subMenus}
            onSearch={this.handleSearch}
            searchQueryValue={searchQuery}
          />}
          <section className={"menu-categories" + (darkMode ? " dark-mode" : "") + (isCompact ? " compact-mode" : "")} aria-label="menu sections">
            {searchActive && (
              <div className="search-info-bar">
                <span className="search-count">
                  Found {totalSearchResults} {totalSearchResults === 1 ? 'item' : 'items'} matching "{searchQuery}"
                </span>
                <button
                  className="search-reset"
                  onClick={() => this.handleSearch('')}
                  aria-label="Reset search"
                >
                  Reset
                </button>
              </div>
            )}

            {/* View Toggle Button */}
            <div className="menu-view-toggle">
              <button 
                className={`toggle-btn ${!isCompact ? 'active' : ''}`}
                onClick={() => this.setState({ compactMode: false })}
                aria-label="Regular view"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="7" height="7"/>
                  <rect x="14" y="3" width="7" height="7"/>
                  <rect x="3" y="14" width="7" height="7"/>
                  <rect x="14" y="14" width="7" height="7"/>
                </svg>
              </button>
              <button 
                className={`toggle-btn ${isCompact ? 'active' : ''}`}
                onClick={() => this.setState({ compactMode: true })}
                aria-label="Compact view"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <line x1="3" y1="12" x2="21" y2="12"/>
                  <line x1="3" y1="18" x2="21" y2="18"/>
                </svg>
              </button>
            </div>
            
            {searchActive && filteredSubMenus.length === 0 && (
              <div className="no-search-results">
                <p>No items found for "{searchQuery}"</p>
                <button
                  className="search-reset"
                  onClick={() => this.handleSearch('')}
                  aria-label="Clear search"
                >
                  Clear search
                </button>
              </div>
            )}
            {filteredSubMenus
                .filter((subMenu) => {
                  const tag = subMenu.tag || ''
                  if (tag.indexOf('hide') !== -1) {
                    return false
                  }
                  return true
                })
                .map(({id, name, products, description, disableOrder, tag}) => {
                if (this.props.disableOrder) {
                  disableOrder = true
                }
                if (this.props.productFilter) {
                  products = products.filter((product) => {
                    return this.props.productFilter(product, {name})
                  })
                }
                const tagCSS = tag ? ` ${tag}` : ""
                const isHashHighlighted = highlightedCategoryId === String(id)
                const isCopied = copiedCategoryId === String(id) || copiedCategoryId === id
                return(
                  <div className={"category" + tagCSS} key={id}>
                    <header className={"category__header" + (isHashHighlighted ? " hash-highlight" : "")}>
                      <div className="category-header-row">
                        <h3
                          id={`menu-category-${id}`}
                          className={"category-name" + (isHashHighlighted ? " hash-highlight" : "")}>
                          <span className="text">{name && name.en}</span>
                        </h3>
                        <button
                          type="button"
                          className="category-share-btn"
                          onClick={() => this.copyCategoryLink(id)}
                          aria-label={`Copy link to ${name && name.en}`}
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.29 1.3" />
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.29-1.3" />
                          </svg>
                          {/* <span className="share-text"></span> */}
                          {isCopied && <span className="copy-tooltip">Copied link</span>}
                        </button>
                      </div>
                      {!isCompact && description && <p className="category__description">
                        {description && description.en}
                      </p>}
                    </header>
                    {(false) ?
                    <PromoAccessForm>
                      <MenuCategoryListView
                        settings={settings}
                        limitedStock={this.props.limitedStock}
                        categoryName={name && name.en}
                        disableOrder={disableOrder}
                        altStyleA={altStyleA}
                        noPhoto={noPhoto}
                        compactMode={isCompact}
                        items={products}
                        width={this.props.width || 180}
                        openPhotoSwipeGallery={this.openPhotoSwipeGallery}
                      />
                    </PromoAccessForm>
                    :
                    <MenuCategoryListView
                      noOrder={noOrder}
                      settings={settings}
                      limitedStock={this.props.limitedStock}
                      categoryName={name && name.en}
                      disableOrder={disableOrder}
                      altStyleA={altStyleA}
                      noPhoto={noPhoto}
                      compactMode={isCompact}
                      items={products}
                      width={this.props.width || 180}
                      openPhotoSwipeGallery={this.openPhotoSwipeGallery}
                    />}
                  </div>
                )
              })
            }
            {searchActive && totalSearchResults > 0 && (
              <div className="search-result-note">
                <span>Showing search results for "{searchQuery}"</span>
                <button
                  className="search-reset"
                  onClick={() => this.handleSearch('')}
                  aria-label="Reset search to full menu"
                >
                  Reset to full menu
                </button>
              </div>
            )}
          </section>
        </div>
      </div>

     
      {this.state.galleryIsOpen && <div className="test-test">
        <button onClick={this.onAddCurrentSlideToCart}>Add To Cart</button>
      </div>}
    </div>)


  }
}

// const AutoMenuWithRouter = withRouter(AutoMenu)
const AutoMenuWithRouter = withRouter(AutoMenu)
const WithContext = (props) => {
  return(
    <Consumer>
      {({menu, settings, limitedStock}) => {
        return(<AutoMenuWithRouter {...props} menu={menu} settings={settings} limitedStock={limitedStock || {}}></AutoMenuWithRouter>)
      }}
    </Consumer>
  )
}
export {AutoMenuWithRouter}
export default WithContext
